import React from 'react';
import gtm from 'eco-design-reliance/gtm';
import EcoLink from 'eco-design/base/eco-link';

import css from './index.module.scss';

const websiteUrl = process.env.NEXT_PUBLIC_WEB_HOST;

export default function ProductItem({ hasImg, pressItem, isMobile = false }: any) {
    const handleLinkClick = (pressItem: any) => {
        if (typeof window !== 'undefined') {
            const searchEntry: any = localStorage.getItem('search_entry');
            const finalTitle = pressItem?.title?.replace(/<em>/g, '').replace(/<\/em>/g, '');

            gtm.push({
                event: 'uaEvent',
                event_name: 'select_article',
                page_name: finalTitle,
                title_name: finalTitle,
                button_name: 'none',
                source_method: searchEntry || '',
            });
        }
    };

    const imgItem = () => {
        const jumpLink = pressItem?.type === 'BLOG' ? `${websiteUrl}${pressItem?.url}` : pressItem?.url;

        return (
            <div className="pressInfo font-family-regular">
                <EcoLink className="articleTitleWrapper" href={jumpLink} onClick={() => handleLinkClick(pressItem)}>
                    <p className="articleTitle" dangerouslySetInnerHTML={{ __html: pressItem?.title }} />
                </EcoLink>

                <p className="articleDesc" dangerouslySetInnerHTML={{ __html: pressItem?.content }} />
                <EcoLink className="articleLink" href={jumpLink} onClick={() => handleLinkClick(pressItem)}>
                    <span className="font-family-medium link">{jumpLink}</span>
                </EcoLink>
            </div>
        );
    };

    return <div className={css.pressItem}>{imgItem()}</div>;
}
